import { GetBusinessAccountAddressesArgs } from 'types/api/arguments/get-business-account-addresses-args'
import { BusinessAccountAddressesResp } from 'types/api/response/business-account-addresses-resp'

import { api } from './api'

export const getBusinessAccountAddresses = ({
  businessAccountId,
}: GetBusinessAccountAddressesArgs) =>
  api.get<BusinessAccountAddressesResp>(`/business_accounts/${businessAccountId}/addresses`)
